import { Monitor, Smartphone, Wrench, HeartHandshake } from "lucide-react";
import { Reveal } from "@/components/Shared";

const ITEMS = [
  { icon: Monitor, label: "Modern Web Experiences" },
  { icon: Wrench, label: "Practical IT Solutions" },
  { icon: Smartphone, label: "Responsive Design" },
  { icon: HeartHandshake, label: "Personalised Support" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="border-y hairline bg-ink2/60 py-7"
      aria-label="What we stand for"
    >
      <div className="container-x grid grid-cols-2 gap-x-6 gap-y-7 lg:grid-cols-4">
        {ITEMS.map(({ icon: Icon, label }, i) => (
          <Reveal
            key={label}
            delay={i * 0.09}
            y={16}
            data-testid={`trust-pillar-${i + 1}`}
            className="flex items-center gap-3.5"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border hairline bg-white/[0.03]">
              <Icon className="h-5 w-5 text-cy" strokeWidth={1.7} />
            </span>
            <span className="font-grotesk text-sm font-medium tracking-tight text-txt sm:text-[15px]">
              {label}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
